import appCore from '../appCore';
import authService from './auth-service';
import accountService from './account-service';
import markingService from './marking-service';

appCore.registerService(authService);
appCore.registerService(accountService);
appCore.registerService(markingService);